export default {
    require: {
        ngModel: 'ngModel'
    },
    bindings: {
        disabled: '<',
        decorate: '@',
        currencyCode: '<'
    },
    controller: 'moneyInputController',
    template: require('../views/money.input.html')
};



// WEBPACK FOOTER //
// ./frontend/admin/app/modules/shared/base/components/money.input.component.js